<ion-card
  no-margin
  margin-top
  no-box-shadow
  class="mobile-view"
  (click)="orderClicked()"
>
  <ion-grid>
    <ion-row>
      <ion-col text-left="">
        <ion-text>
          <div font-medium text-black font-size-14>{{ order.formattedId }}</div>
          <div font-size-10>
            Pick up Date •
            <span font-medium font-size-10>{{
              order.orderDate | date: "dd-MMM-yyyy"
            }}</span>
          </div>
          <div font-size-12 font-medium *ngIf="order.addressInfo.city">
            <ion-text color="primary">{{ order.fromLocation?.name }}</ion-text>
          </div>
        </ion-text>
      </ion-col>
      <ion-col size="auto" text-right="">
        <ion-text
          *ngIf="!status(['ORDER_COMPLETED'], true)"
          [color]="order?.totalAmountOfExclTax > 0 ? 'primary' : 'danger'"
        >
          <div font-medium font-size-14>
            {{ getAbs(order?.totalAmountOfExclTax) | currency: "INR" }}*
          </div>
        </ion-text>
        <ion-text
          *ngIf="status(['ORDER_COMPLETED'], true)"
          [color]="order?.tradeType === 'B' ? 'primary' : 'danger'"
        >
          <div font-medium font-size-14>
            {{ order?.netAmount | currency: "INR" }}*
          </div>
        </ion-text>

        <div *ngIf="!status(['ORDER_COMPLETED'], true)" font-size-10>
          <i>*All rates exclusive of GST</i>
        </div>
        <div *ngIf="status(['ORDER_COMPLETED'], true)" font-size-10>
          <i>*All rates inclusive of GST</i>
        </div>
      </ion-col>
    </ion-row>
    <ion-row align-items-end margin-top>
      <ion-col size="7" text-left="" class="statusLabel">
        <ion-badge
          font-size-12
          text-wrap
          [OrderStatus]="
            order?.status === 'ORDER_COMPLETED'
              ? order?.payment?.orderPaymentStatus
              : order?.status
          "
        >
          {{
            (order?.status === "ORDER_COMPLETED"
              ? order?.payment?.statusTitle
              : order?.displayStatusTitle
            ) | uppercase
          }}
        </ion-badge>
      </ion-col>
      <ion-col size="5" text-right="">
        <ion-text color="medium" font-size-10=""> Qty •</ion-text>
        <ion-text font-size-14="">
          {{ order?.formattedTotalQty || "-" }}</ion-text
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card>
